import { JobStucturedDataProps } from './interfaces';

export const parseJobTimeType = (timeType: string | undefined) => {
  const transformedTimeType = timeType?.toLowerCase().replace(/\s|_/g, '');
  if (transformedTimeType === 'fulltime') {
    return 'FULL_TIME' as const;
  }
  if (transformedTimeType === 'parttime') {
    return 'PART_TIME' as const;
  }
};

export const createEmploymentType = (timeTypes: string[] | undefined) => {
  if (!timeTypes) {
    return;
  }

  if (timeTypes.length === 1) {
    return parseJobTimeType(timeTypes[0]);
  }

  return timeTypes
    .map(parseJobTimeType)
    .filter((value): value is NonNullable<typeof value> => !!value);
};

export const generateJobSchema = ({
  title,
  description,
  startDate,
  endDate,
  employmentType,
  hiringOrganization,
  jobLocation,
}: JobStucturedDataProps) => {
  return {
    title,
    description,
    datePosted: startDate,
    validThrough: endDate,
    employmentType,
    hiringOrganization: {
      '@type': 'Organization',
      ...hiringOrganization,
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        ...jobLocation.address,
      },
    },
  };
};
